import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function advancedEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Cette expression régulière est juste un exemple, tu peux l'ajuster selon tes besoins
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = regex.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
}
